export enum HouseholdDetailsOptions {
  Savings = 'Savings',
  HouseSale = 'HouseSale',
  HouseSaleAndSavings = 'HouseSaleAndSavings',
  Refinance = 'Refinance',
  PayBackAndRefinance = 'PayBackAndRefinance',
  None = 'None'
}
